function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDtr3Tog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15.721905mm",
    height: "24.827337mm",
    viewBox: "0 0 15.721905 24.827337",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-139.78709,-153.43927)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M 147.64858,177.77363 V 153.93225 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 155.01103,177.71921 -7.3358,-23.7375 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 140.28505,177.71921 7.3358,-23.7375 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.999999,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 141.9789,167.00169 h 11.33828 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.999999,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 141.9789,164.70312 h 11.33828 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.999999,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 141.9789,162.40456 h 11.33828 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDtr3Tog);
export default __webpack_public_path__ + "static/media/dtr3tog.271545d76af736e827cd82f733cce19d.svg";
export { ForwardRef as ReactComponent };